import $api from "@/shared/http";
import { toApiError } from "@/shared/http/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "@/app/appStore";
import {
  DEALER_SETTINGS_MARKUPS_URL,
  DEALER_SETTINGS_QUANTITY_URL,
  DEALER_SETTINGS_VISIBILITY_URL,
} from "../../lib/constants";
import {
  mapMarkupsToApi,
  mapQuantityToApi,
  mapVisibilityToApi,
} from "../../lib/mapDealerSettings";
import { cloneSettings } from "../../lib/cloneSettings";
import { StockPublicationSettings } from "../../types";
import { ChangeDealerMarkupsRequestDto } from "../types";

const extractErrorMessage = (error: unknown): string => {
  const apiError = toApiError(error);
  const detail =
    typeof apiError.data === "object" &&
    apiError.data !== null &&
    "detail" in apiError.data &&
    typeof (apiError.data as { detail: unknown }).detail === "string"
      ? (apiError.data as { detail: string }).detail
      : apiError.message;

  return detail || "Не удалось сохранить настройки";
};

export const saveStockPublicationSettings = createAsyncThunk<
  StockPublicationSettings,
  StockPublicationSettings,
  { rejectValue: string; state: RootState }
>(
  "stockPublication/saveStockPublicationSettings",
  async (settings, { rejectWithValue, getState }) => {
    const dictionaries = getState().stockPublication.dictionaries;

    if (!dictionaries) {
      return rejectWithValue("Справочники не загружены");
    }

    try {
      const markupsBody: ChangeDealerMarkupsRequestDto = {
        markups: mapMarkupsToApi(settings.markups, dictionaries),
      };

      await Promise.all([
        $api.post(
          DEALER_SETTINGS_VISIBILITY_URL,
          mapVisibilityToApi(settings, dictionaries),
        ),
        $api.post(DEALER_SETTINGS_QUANTITY_URL, mapQuantityToApi(settings)),
        $api.post(DEALER_SETTINGS_MARKUPS_URL, markupsBody),
      ]);

      return cloneSettings(settings);
    } catch (error) {
      return rejectWithValue(extractErrorMessage(error));
    }
  },
);
